import { render, staticRenderFns } from "./BillingTables.vue?vue&type=template&id=94fe89a0&scoped=true&"
import script from "./BillingTables.vue?vue&type=script&lang=js&"
export * from "./BillingTables.vue?vue&type=script&lang=js&"
import style0 from "./BillingTables.vue?vue&type=style&index=0&id=94fe89a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fe89a0",
  null
  
)

export default component.exports